<template>
    <section class="app">
        <div class="row center-block">
            <!-- <h1 class="text-center">App</h1> -->
            <div class="col-md-12 divDeveloperDocumentation"> 
                 <h1 class="developerDocumentationSdk  nuwaDevelop">Nuwa Robot SDK</h1>
                 <h1 class="developerDocumentationDer  nuwaDevelop">Ver 0.37</h1>
            </div>
            <div class="col-md-12 divDeveloperDocumentationDownload"> 
                 <h3 class="developerDocumentationDownload nuwaDevelop">Download</h3>
            </div>
            <div class="col-md-12 div_path_3">
                <button class="rectangle_9" ><span class="buttonTxt">SDK</span></button>
                <button class="rectangle_9" ><span class="buttonTxt">Sample Code</span></button>
                <button class="rectangle_9" ><span class="buttonTxt">PDF</span></button>
            </div>
            <div class="col-md-12">
                <div class="box">
                    <div class="box-header col-md-2">
                        <!-- <h3 class="box-title">List</h3> -->
                    </div>

                    <div class="box-header col-md-8 text-center">
                        <div 
                        v-if="client.clientId"
                        class="box-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <label>client id:</label>
                                </div>
                                <div class="col-md-10">
                                    <input
                                            v-model="client.clientId"
                                            class="form-control"
                                            disabled
                                            type="text">
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-2">
                                    <label>client secret:</label>
                                </div>
                                <div class="col-md-10">
                                    <input
                                            v-model="client.clientSecret"
                                            class="form-control"
                                            disabled
                                            type="text">
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="box-header col-md-2 text-right">
                        <button
                            type="button"
                            data-toggle="modal"
                            :data-target="targetModalId"
                            data-placement="top"
                            :title="$t('add')"
                            :class="'btn btn-lg btn-primary'"
                            @click="$_admin_app_action_c()"
                            >
                            <i
                                class="fa fa-plus"
                                aria-hidden="true">
                            </i> &nbsp;Add
                        </button>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <div
                            id="example_wrapper"
                            class="dataTables_wrapper form-inline dt-bootstrap">

                            <div class="row">
                                <div class="col-sm-12 table-responsive">
                                    <div id="app">
                                        <v-server-table
                                            url="/"
                                            :columns="columns"
                                            :options="options">
                                            <div slot="filter__checkbox">
                                                <input
                                                    v-model='allMarked'
                                                    type="checkbox"
                                                    v-on:change="$_admin_app_list_toggleAll()"
                                                />
                                                &nbsp;
                                                <button
                                                    class="btn btn-danger btn-sm"
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    :title="$t('deleteSelected')"
                                                    @click="$_admin_app_list_removeAll()">
                                                    <i class="glyphicon glyphicon-trash"></i>
                                                </button>
                                            </div>


                                            <template slot="checkbox" slot-scope="props">
                                                <input
                                                    v-model="markedRows"
                                                    type="checkbox"
                                                    v-bind:value="props.row.appId"
                                                    v-on:change="$_admin_app_list_unmarkAll()"
                                                />
                                            </template>
                                        </v-server-table>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- /.box-body -->
                    </div>

                    <div class="modal modal-info fade" :id="modalId" style="display: none;">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span></button>
                                    <h4 class="modal-title">{{$i18n.messages[$i18n.locale].addApp}}</h4>
                                </div>

                                <div class="modal-body">
                                    <form class="ui form addAppForm">
                                        <div class="row" v-bind:class="{ 'has-error2': $v.newApp.keyName.$invalid }">
                                            <div class="col-md-3 text-left">
                                                <label style="color: red;">*</label>
                                                {{$i18n.messages[$i18n.locale].keyName}} :
                                            </div>
                                            <div class="col-md-8">
                                                <input
                                                    v-model="newApp.keyName"
                                                    class="form-control"
                                                    placeholder="key"
                                                    type="text">
                                            </div>
                                        </div>
                                        <div class="row" v-bind:class="{ 'has-error2': $v.newApp.platform.$invalid }">
                                            <div class="col-md-3 text-left">
                                                <label style="color: red;">*</label>
                                                {{$i18n.messages[$i18n.locale].platform}} :
                                            </div>
                                            <div class="col-md-8">
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <input
                                                            id="platform1"
                                                            v-model="newApp.platform"
                                                            value="android"
                                                            type="radio" />
                                                        <label for="platform1">android</label>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <input
                                                            id="platform2"
                                                            v-model="newApp.platform"
                                                            value="ios"
                                                            type="radio" />
                                                        <label for="platform2">ios</label>
                                                    </div>
                                                </div>
                                                
                                                
                                                
                                            </div>
                                        </div>
                                        <div class="row" v-bind:class="{ 'has-error2': $v.newApp.publishSecret.$invalid }">
                                            <div class="col-md-3 text-left">
                                                <label style="color: red;">*</label>
                                                {{$i18n.messages[$i18n.locale].publishSecret}} :
                                            </div>
                                            <div class="col-md-8">
                                                <input
                                                    v-model="newApp.publishSecret"
                                                    class="form-control"
                                                    placeholder="key"
                                                    type="text">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3 text-left">{{$i18n.messages[$i18n.locale].testSecret}} :</div>
                                            <div class="col-md-8">
                                                <input
                                                    v-model="newApp.testSecret"
                                                    class="form-control"
                                                    placeholder="key"
                                                    type="text">
                                            </div>
                                        </div>
                                        <div class="row" v-bind:class="{ 'has-error2': $v.newApp.packageName.$invalid }">
                                            <div class="col-md-3 text-left">
                                                <label style="color: red;">*</label>
                                                {{$i18n.messages[$i18n.locale].package}} :
                                            </div>
                                            <div class="col-md-8">
                                                <input
                                                    v-model="newApp.packageName"
                                                    class="form-control"
                                                    placeholder="key"
                                                    type="text">
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div class="modal-footer">
                                    <button
                                        type="button"
                                        class="btn btn-outline"
                                        @click="$_admin_app_add_checkAddApp()"
                                    >
                                        {{$i18n.messages[$i18n.locale].submit}}
                                    </button>
                                </div>
                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->

                        <div v-bind:class="{overlay: true, hidden: !loading}">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import moment from 'moment'
    import api from '../../api'
    import config from '../../config'
    import action from './ListAppAction2'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'AppList',
        components: {
        },
        validations () {
            let data = {
                newApp: {
                    packageName: {
                        required
                    },
                    keyName: {
                        required
                    },
                    platform: {
                        required
                    },
                    publishSecret: {
                        required
                    }
                }
            }
            return data
        },
        mounted () {
            this.modalId = 'modal-add'
            this.targetModalId = '#modal-add'
        },
        watch: {
            '_i18n.locale': function (newVal, oldVal) {
                const i18nSetting = this.$_admin_app_list_translation()
                this.columns = i18nSetting.columns
                this.options.templates = i18nSetting.templates
                this.options.texts = i18nSetting.texts
                this.options.filterable = i18nSetting.filterable
                this.options.listColumns = i18nSetting.listColumns
                this.options.columnsClasses = i18nSetting.columnsClasses
                for (let i = 0; i < i18nSetting.filterable.length; i++) {
                    this.$children[0].query[i18nSetting.filterable[i]] = ''
                }
            },
            isRefresh: function (newVal, oldVal) {
                this.$children[0].refresh()
            }
        },
        data () {
            const i18nSetting = this.$_admin_app_list_translation()
            return {
                totalRow: [],
                allMarked: false,
                markedRows: [],
                columns: i18nSetting.columns,
                options: {
                    filterByColumn: true,
                    templates: i18nSetting.templates,
                    texts: i18nSetting.texts,
                    filterable: i18nSetting.filterable,
                    listColumns: i18nSetting.listColumns,
                    columnsClasses: i18nSetting.columnsClasses,
                    sortable: [],
                    debounce: 1000,
                    perPage: 10,
                    requestKeys: {
                        limit: 'limit',
                        orderBy: 'sort',
                        page: 'page'
                    },
                    requestFunction: this.$_admin_app_list_requestFun,
                    responseAdapter (resp) {
                        this.totalRow = resp.payload
                        return { data: resp.payload, count: resp.query.total }
                    }
                },
                client: {},
                modalId: '',
                targetModalId: '',
                loading: false,
                newApp: {
                    packageName: '',
                    keyName: '',
                    platform: '',
                    publishSecret: '',
                    testSecret: ''
                }
            }
        },
        methods: {
            $_admin_app_list_requestFun (data) {
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiApp
                const headers = {'authorization': this.$store.state.token}
                const params = Object.assign({}, data)
                if (data.query.status) {
                    params.status = data.query.status
                }
                if (data.query['keyName']) {
                    params.keyName = data.query['keyName']
                }
                if (data.query['appId']) {
                    params.appId = data.query['appId']
                }
                console.log('query param===')
                delete params.query
                delete params.sort
                delete params.ascending
                delete params.byColumn
                return api.request('get', path, {}, params, headers)
                    .then(response => {
                        if (response.data.data.payload && response.data.data.payload.length > 0) {
                            this.client = response.data.data.payload[0]
                        }
                        return Promise.resolve(response.data.data)
                    })
                    .catch(function (e) {
                        this.$children[0].dispatch('error', e)
                    }.bind(this))
            },
            $_admin_app_list_unmarkAll () {
                this.allMarked = false
            },
            $_admin_app_list_toggleAll () {
                this.markedRows = this.allMarked ? this.$children[0].data.map(row => row.appId) : []
            },
            $_admin_app_list_removeAll () {
                let ids = []
                this.$children[0].data.map((row, index) => {
                    this.markedRows.map(markRow => {
                        if (row.appId === markRow) {
                            ids.push(row.appId)
                            delete this.$children[0].data[index]
                        }
                    })
                })
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiApp
                const headers = {'authorization': this.$store.state.token}
                const params = { ids: ids.join(',') }
                return api.request('delete', path, {}, params, headers)
                    .then(response => {
                        this.$children[0].refresh()
                    })
            },
            $_admin_app_list_translation (langCode) {
                const i18n = this.$parent.$i18n
                const locale = i18n.locale
                const updatedAt = i18n.messages[locale].updatedAt
                let result = {}
                result.columns = ['checkbox', 'keyName', 'platform', 'appId', 'expire', updatedAt, 'action']
                result.templates = {
                    action
                }
                result.templates['expire'] = function (h, row) {
                    const time = moment(row.expire * 1000).format('YYYY-MM-DD HH:mm:ss')
                    return time
                }
                result.templates[updatedAt] = function (h, row) {
                    const time = moment(row.updatedAt).format('YYYY-MM-DD HH:mm:ss')
                    return time
                }
                result.texts = {
                    filterBy: i18n.messages[locale].filterBy,
                    defaultOption: i18n.messages[locale].defaultOption
                }
                result.filterable = ['keyName', 'appId']
                result.listColumns = {}
                result.columnsClasses = {}
                result.columnsClasses['checkbox'] = 'col-md-1'
                result.columnsClasses['keyName'] = 'col-md-3'
                result.columnsClasses['platform'] = 'col-md-1'
                result.columnsClasses['appId'] = 'col-md-2'
                result.columnsClasses['expire'] = 'col-md-2'
                result.columnsClasses[updatedAt] = 'col-md-2'
                result.columnsClasses['action'] = 'col-md-1'
                return result
            },
            $_admin_app_action_c () {
                console.log('---??')
            },
            $_admin_app_add_checkAddApp () {
                const {keyName, platform, publishSecret, testSecret, packageName} = this.newApp
                this.$_admin_app_add_toggleLoading()
                const headers = {'authorization': this.$store.state.token}
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiApp
                /* eslint-disable object-property-newline */
                let body = {keyName, platform, publishSecret, package: packageName}
                if (testSecret) {
                    body.testSecret = testSecret
                }
                api.request('post', path, body, {}, headers)
                    .then(response => {
                        const data = response.data
                        /* Checking if error object was returned from the server */
                        if (data.error) {
                            const errorName = data.error.name
                            if (errorName) {
                                this.response = errorName
                            } else {
                                this.response = data.error
                            }

                            return
                        }
                        /* Setting app in the state and caching record to the localStorage */
                        if (response.data.status.code === 0) {
                            this.insertSuccess = true
                            console.log('in ???---')
                            this.$_admin_app_add_toggleLoading()
                            window.$('#modal-add').modal('hide')
                            this.$children[0].refresh()
                        }
                    })
                    .catch(error => {
                        this.$store.commit('TOGGLE_LOADING')
                        console.log(error)

                        this.response = 'Server appears to be offline'
                        this.$_admin_app_add_toggleLoading()
                    })
            },
            $_admin_app_add_toggleLoading () {
                this.loading = !this.loading
            }
        }
    }
</script>

<style scoped>
    /* Using the bootstrap style, but overriding the font to not draw in
       the Glyphicons Halflings font as an additional requirement for sorting icons.

       An alternative to the solution active below is to use the jquery style
       which uses images, but the color on the images does not match adminlte.

    @import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
    */
    
    @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

    table.dataTable thead .sorting:after,
    table.dataTable thead .sorting_asc:after,
    table.dataTable thead .sorting_desc:after {
        font-family: 'FontAwesome';
    }

    table.dataTable thead .sorting:after {
        content: "\f0dc";
    }

    table.dataTable thead .sorting_asc:after {
        content: "\f0dd";
    }

    table.dataTable thead .sorting_desc:after {
        content: "\f0de";
    }

    .addAppForm > .row {
        margin-top: 15px;
    }

    .addAppForm > .has-error3 input {
        background-color: #f8c9c8;
        border-color: #f18482;
        border-width: 2px;
    }

    #modal-add .modal-body, #modal-add .modal-footer {
        background-color: white !important;
        color: black !important;
    }
    #modal-add .btn-outline {
        color: black;
        border: 1px solid #3c8dbc;
    }

    /* [fu] */
 .main-sidebar{
     display: none!important;
 }
 .nuwaDevelop{
    margin: 0;
    }
.center-block{
    margin-top: 118px;
}
.developerDocumentationSdk {
  /* width: 337px; */
  height: 59px;
  font-family: sans-serif;
  font-size: 40px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.2px;
  color: #333333;
  margin-right: 28px;
}
.developerDocumentationDer {
  /* width: 159px; */
  height: 59px;
  font-family: sans-serif;
  font-size: 40px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.2px;
  color: #333333;
}
.developerDocumentationDownload {
  width: 112px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: #333333;
}
.divDeveloperDocumentationDownload{
    margin-top:32px; 
}
.divDeveloperDocumentation{
  display: flex;
}
.rectangle_9  {
  width: 220px;
  height: 50px;
  border-radius: 10px;
  background-color: #00b5e2;
  /* background-color: var(--aqua-blue); */
  outline: none;
  border: none;
}
.buttonTxt {
  width: 156px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  text-align: center;
  color: #ffffff;
}
.div_path_3 > button{
    margin-right:48px; 
}
.div_path_3{
    margin-top: 34px;
}
</style>



// WEBPACK FOOTER //
// Build.vue?244c747f